import React from 'react'

import { ContentStateProperty, FieldProps } from '../../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../../@types/validation-types'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { EfficiencyClassOption } from '../../../../../../../@types/dropdown-types'

const property = 'efficiencyClass'

export interface EfficiencyClassProps extends Omit<FieldProps<ConstructionScreenValidationResult>, 'onChange'> {
  onEnergyCertificateChange: (field: ContentStateProperty, value: string | boolean | undefined) => void
}

const EfficiencyClassField: React.FC<EfficiencyClassProps> = ({ insertionData, onEnergyCertificateChange }) => {
  return (
    <div className='grid-item four-fifth margin-top-l'>
      <DropdownSelect
        id='efficiency-class'
        data-testid='efficiency-class'
        label='wizard.screen.construction.efficiencyClass'
        name={property}
        noInformation={EfficiencyClassOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.construction.efficiencyClassType',
          options: Object.keys(EfficiencyClassOption),
        }}
        value={insertionData.efficiencyClass}
        onChange={(value) => onEnergyCertificateChange(property, value.value)}
      />
    </div>
  )
}

export default EfficiencyClassField
